/**
 * LearningPointsSection — "Det här lär du dig" for course-type activities.
 * Only renders if event_type === 'course' and learning_points has content.
 */
import { CheckCircle } from 'lucide-react';

interface LearningPointsSectionProps {
  learningPoints: string[] | null | undefined;
}

export function LearningPointsSection({ learningPoints }: LearningPointsSectionProps) {
  const points = learningPoints?.filter(p => p.trim().length > 0);
  if (!points || points.length === 0) return null;

  return (
    <div className="space-y-3">
      <h2 className="text-lg font-semibold text-foreground">Det här lär du dig</h2>
      <ul className="space-y-2">
        {points.map((point, i) => (
          <li key={i} className="flex items-start gap-2.5">
            <CheckCircle className="h-4 w-4 text-[hsl(var(--course-badge-fg))] shrink-0 mt-0.5" />
            <span className="text-sm text-muted-foreground leading-relaxed">{point}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
